import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,VALID_STRING_PATTERN,INPUT_TEXT_LIMIT,VALID_EMAIL_PATTERN,PASSWORD_MIN_LENGTH,PASSWORD_MAX_LENGTH } from './../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as trans from '../FrontMessages';
import { ROUTE_SIGN_UP,ROUTE_FORGOT_PASSWORD } from '../RouteConstents';
import ShowError from "./ShowError";
import { textLimitMessage } from './../AppHelper';

const CompleteProfile = () => {       

    const navigate = useNavigate();

    const { string } = useParams();

    const {register, handleSubmit, formState: { errors },setValue } = useForm();
    
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    useEffect(
        () => {
        document.body.classList.add('login-page');
    });        
    
    const onSubmit = async (data) => {

        let formPassword = data.password;
        let formcPassword = data.confirmPassword;

        if(formPassword != formcPassword) {
            toast.error('Password and confirm password does not match.');     
            return false;
        }

        let objValue =  {
            "method_name":"completeProfile",
            "phone_id":string,
            "first_name": data.firstName,
            "last_name": data.lastName,
            "email": data.email,
            "password": data.password,
            "confirm_password": data.confirmPassword
        }

        await axios.post(API_URL,objValue).then(function (response) {
            if (response.status === RESPONSE_SUCCESS) {
                if(response.data.status === "success") {
                    toast.success(response.data.message); 
                    localStorage.setItem("userInfo", JSON.stringify(response.data.userInfo));
                    navigate('/dashboard');
                } else {
                   toast.error(response.data.message); 
                }
            }
        
        }).catch(function (error) {
            toast.error(error.message);
        });
        
    }

    return (
        <div style={{ backgroundColor: '#00BCD4' }}>
            
            <div className="login-box">
                <div className="logo">
                    <img src="/assets/images/logo.png" alt="SBS" width="100" />
                </div>
                <div className="card ">
                    <div className="body">
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                            <br/>
                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        name="firstName"
                                        placeholder="First Name" 
                                        onChange={(e) => setFirstName(e.target.value)}
                                        {...register("firstName",{ 
                                            required: trans.PLEASE_ENTER_FIRST_NAME,
                                            pattern: {
                                                value: VALID_STRING_PATTERN,
                                                message: trans.PLEASE_ENTER_VALID_FIRST_NAME
                                            },
                                            maxLength: {
                                                value: INPUT_TEXT_LIMIT,
                                                message: textLimitMessage()
                                            }
                                        })}
                                    />
                                </div>
                                <ShowError errorsModal={errors.firstName} /> 
                            </div>

                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        name="lastName"
                                        placeholder="Last Name" 
                                        onChange={(e) => setLastName(e.target.value)}
                                        {...register("lastName",{ 
                                            required: trans.PLEASE_ENTER_LAST_NAME,
                                            pattern: {
                                                value: VALID_STRING_PATTERN,
                                                message: trans.PLEASE_ENTER_VALID_LAST_NAME
                                            },
                                            maxLength: {
                                                value: INPUT_TEXT_LIMIT,
                                                message: textLimitMessage()
                                            }  
                                        })}
                                    />
                                </div>
                                <ShowError errorsModal={errors.lastName} /> 
                            </div>

                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        name="email"
                                        placeholder="Email" 
                                        onChange={(e) => setEmail(e.target.value)}
                                        {...register("email",{ 
                                            required: false,
                                            pattern: {
                                                value: VALID_EMAIL_PATTERN,
                                                message: trans.PLEASE_ENTER_VALID_EMAIL
                                            }
                                            
                                        } ) }
                                    />
                                </div>
                                <ShowError errorsModal={errors.email} /> 
                            </div>

                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        name="password"
                                        placeholder="Password" 
                                        onChange={(e) => setPassword(e.target.value)}
                                        {...register("password",{ 
                                            required: trans.PLEASE_ENTER_PASSWORD,
                                            minLength: {
                                                value: PASSWORD_MIN_LENGTH,
                                                message: trans.PLEASE_ENTER_PASSWORD_LENGTH
                                            },
                                            maxLength: {
                                                value: PASSWORD_MAX_LENGTH,
                                                message: trans.PLEASE_ENTER_PASSWORD_LENGTH
                                            } 
                                        })}
                                    />
                                </div>
                                <ShowError errorsModal={errors.password} />
                            </div>

                            <div className="input-group">
                                <div className="form-line">
                                    <input 
                                        type="password" 
                                        className="form-control" 
                                        name="confirmPassword"
                                        placeholder="Confirm Password" 
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        {...register("confirmPassword",{ 
                                            required: trans.PLEASE_ENTER_CONFIRM_PASSWORD,
                                            minLength: {
                                                value: PASSWORD_MIN_LENGTH,
                                                message: trans.PLEASE_ENTER_CONFIRM_PASSWORD_LENGTH
                                            },
                                            maxLength: {
                                                value: PASSWORD_MAX_LENGTH,
                                                message: trans.PLEASE_ENTER_CONFIRM_PASSWORD_LENGTH
                                            }   
                                        })}
                                    />
                                </div>
                                <ShowError errorsModal={errors.confirmPassword} />
                            </div>

                            
                            
                            <div className="row">
                                <div className="col-xs-12 text-center">
                                    <button className="btn bg-pink waves-effect" type="submit">Complete Profile</button>
                                </div>
                            </div>
                           
                        </form>
                    </div>
                </div>
            </div>
                
        </div>
    );
   
}
    
export default CompleteProfile;